module.exports = __webpack_public_path__ + "static/bg07-ee18d284e17c717f6a3b42851b6cc983.webp";